import React from 'react';
import '../components/Vision.css';
import afgMap from '../images/IMG_3140.JPG.jpeg';

const AboutNORA: React.FC = () => {
  const scopeOfWork = [
    {
      title: 'About NORA',
      description: 'Empowering Afghan communities through sustainable development in health, education, AI, and digital skills.',
      icon: 'fas fa-handshake'
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>About NORA, Mission, Vision, & Core Values</h2>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA NGO Operational Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Scope of Work Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {scopeOfWork.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Who We Are</strong></h3>
                </div>
                <p className="scope-card-description">
                  <strong>Noor Organization for Rehabilitation of Afghanistan (NORA) is a national non-governmental organization founded by a dedicated team of professors from Kabul Polytechnic University, Kabul Medical University, and Kabul Education University, together with experienced Medical Specialists, Artificial Intelligence Specialists, Researchers, Development Professionals, and Humanitarian Practitioners who share a common vision for Afghanistan's sustainable future.</strong>
                  <br/><br/>
                  Recognizing Afghanistan's rich cultural heritage, resilient communities, and the transformative potential of technology, NORA was established to improve the quality of life of Afghan people through integrated programs in health, education, Artificial Intelligence (AI), digital skills, innovation, and community development.
                  <br/><br/>
                  Afghanistan has faced decades of social, economic, and political challenges that have significantly affected education, healthcare, employment, and access to modern technologies. Despite these difficulties, Afghan communities continue to demonstrate remarkable resilience, creativity, and determination to build a better future. NORA was founded on the principles of integrity, inclusion, innovation, collaboration, and respect for local communities, believing that sustainable development begins with empowering people through knowledge and opportunity.
                  <br/><br/>
                  <strong>Our approach is community-centered and locally driven.</strong> We work closely with community members, educational institutions, government agencies, civil society organizations, and development partners to design solutions that are culturally appropriate, sustainable, and responsive to local priorities. By combining academic excellence with practical field experience, NORA develops programs that address today's humanitarian and development needs while preparing Afghan youth for tomorrow's digital economy.
                  <br/><br/>
                  In addition to implementing programs in health and education, NORA actively promotes Artificial Intelligence, Digital Skills, Software Development, Digital Transformation, and Technology Innovation as strategic pillars for Afghanistan's future. Our team designs and develops digital systems, management information systems, educational platforms, AI-powered applications, and technology solutions for government institutions, educational organizations, NGOs, and private-sector partners. At the same time, we equip Afghan women and youth with practical digital competencies that enable them to access remote employment, freelancing opportunities, entrepreneurship, and careers in the global digital economy.
                  <br/><br/>
                  Through our integrated approach, NORA aims to strengthen human capital, modernize institutions through technology, expand digital inclusion, and create sustainable opportunities for economic empowerment. We remain committed to transparency, accountability, innovation, and continuous learning to ensure our programs deliver measurable and lasting impact.
                  <br/><br/>
                  Working in partnership with national and international organizations, universities, government institutions, technology companies, and local communities, NORA is committed to building a healthier, more educated, digitally empowered, and prosperous Afghanistan. Our mission is to empower individuals and institutions to become active contributors to national development and to inspire lasting positive change across the country.
                  <br/><br/>
                  <h3 style={{ color: 'green', fontWeight: 'bold', fontSize: '1.9rem' }}>Our Vision</h3>
                  <br/>
                  <strong className="scope-card-description">To become Afghanistan's most trusted and leading technology-driven organization, empowering youth through innovation, digital skills, and technology to transform education, healthcare, and sustainable economic development.</strong>
                  <br/><br/>
                  <h3 style={{ color: 'green', fontWeight: 'bold', fontSize: '1.9rem' }}>Our Mission</h3>
                  <br/>
                  <strong className="scope-card-description"> To empower Afghan youth by leveraging technology and innovation to transform education, improve healthcare, build digital skills, and create sustainable pathways for employment, entrepreneurship, and inclusive development.</strong>
                  <br/><br/>
                  <br/><br/>
                  
                  {/* Enhanced Core Values Section */}
                  <div className="core-values-wrapper">
                    <div className="core-values-header">
                      <h3 style={{ color: 'green', fontWeight: 'bold', fontSize: '1.9rem' }} className="core-values-title">Our Core Values</h3>
                      <p className="core-values-subtitle">
                        These principles guide every program, partnership, and decision at NORA.
                      </p>
                    </div>

                    <div className="core-values-table-container">
                      <div className="core-values-grid">
                        {/* Value 1 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">01</div>
                            <div className="core-value-icon">
                              <i className="fas fa-shield-alt"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Integrity & Accountability</h4>
                            <p>
                              We use resources responsibly, communicate honestly, prevent conflicts
                              of interest, and remain accountable to communities, partners, donors,
                              and governing bodies.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Ethics</span>
                            <span className="value-tag">Transparency</span>
                          </div>
                        </div>

                        {/* Value 2 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">02</div>
                            <div className="core-value-icon">
                              <i className="fas fa-users"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Inclusion & Dignity</h4>
                            <p>
                              We design for people who face the greatest barriers and respect local
                              culture, language, ability, age, and gender.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Equality</span>
                            <span className="value-tag">Respect</span>
                          </div>
                        </div>

                        {/* Value 3 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">03</div>
                            <div className="core-value-icon">
                              <i className="fas fa-hands-helping"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Local Ownership</h4>
                            <p>
                              Afghan communities and institutions help define problems, shape
                              solutions, monitor quality, and sustain results.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Community</span>
                            <span className="value-tag">Empowerment</span>
                          </div>
                        </div>

                        {/* Value 4 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">04</div>
                            <div className="core-value-icon">
                              <i className="fas fa-lightbulb"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Innovation with Purpose</h4>
                            <p>
                              We adopt technology only when it is useful, appropriate, safe,
                              affordable, and maintainable in the local context.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Technology</span>
                            <span className="value-tag">Impact</span>
                          </div>
                        </div>

                        {/* Value 5 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">05</div>
                            <div className="core-value-icon">
                              <i className="fas fa-chart-line"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Evidence & Learning</h4>
                            <p>
                              We test assumptions, measure outcomes, learn from experience, and
                              continuously improve based on credible evidence and community
                              feedback.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Data</span>
                            <span className="value-tag">Growth</span>
                          </div>
                        </div>

                        {/* Value 6 */}
                        <div className="core-value-card">
                          <div className="card-header">
                            <div className="core-value-number">06</div>
                            <div className="core-value-icon">
                              <i className="fas fa-heart"></i>
                            </div>
                          </div>
                          <div className="card-body">
                            <h4>Do No Harm</h4>
                            <p>
                              We protect children and adults at risk, uphold data protection,
                              assess digital and AI risks, and prioritize safety in every
                              intervention.
                            </p>
                          </div>
                          <div className="card-footer">
                            <span className="value-tag">Safety</span>
                            <span className="value-tag">Protection</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutNORA;